export default {
  "create-success": {
    EN: "Successfully created Product Type.",
  },
  "create-failure": {
    EN: "Failed to create Product Type",
  },
  "update-success": {
    EN: "Successfully updated Product Type.",
  },
  "update-failure": {
    EN: "Failed to update Product Type",
  },
  "read-failure": {
    EN: "Failed to read Product Type. Please refresh the page and try again.",
  },
  "delete-success": {
    EN: "Successfully deleted Product Type.",
  },
  "delete-failure": {
    EN: "Failed to delete Product Type. Cannot delete a Product Type that has at least 1 Product.",
  },
  "delete-confirm": {
    EN: "Are you sure you want to delete this product type?",
  },
};
